/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */

import { Box, Button, Dialog, DialogActions, Grid, Paper, Typography } from '@mui/material';
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { Prompt } from 'react-router-dom/cjs/react-router-dom';

import { showToast } from 'modules/layout/layout.actions';
import AdvancedSearch from 'modules/common/advancedSearch.component';
import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS, DRAWER_WIDTH_OPEN } from 'styles/theme';

import VoucherInfoCard from './voucherInfoCard.component';
import VoucherLineItems from './voucherLineItems.component';
import DynamicFilePreviewCard from 'modules/expenses/common/dynamicFilePreviewCard.component';
import RepayAgreementInfoBox from 'modules/expenses/common/repayAgreementInfoBox.component';

import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { POST_PUSH_VOUCHER_TO_ACUMATICA_FAILURE, UPDATE_VOUCHER_SUMMARY_FAILURE } from 'modules/expenses/store/types';
import SpinnerComponent from 'modules/common/spinner.component';
import Spinner from 'modules/common/spinner.component';

import { EXPENSES_PAYEE_TYPE, VOUCHER_STATUS, ZERO_GUID } from 'modules/enumerations/enumerationIds';
import { getCurrencyOptions, isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { GUIDS, TRACK_VOUCHER_TYPE_ID } from '../voucherConstants';
import { VoucherStartOverTypes } from './voucherDetailsView.container';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: { display: 'flex', flexDirection: 'row' },
  dialogIconRow: { display: 'flex', flexDirection: 'row', padding: '40px', paddingBottom: '20px' },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  drawerOpen: { width: `calc(100% - ${DRAWER_WIDTH_OPEN})` },
  headerFixed: { zIndex: 4 },
  tabFixed: { paddingTop: '100px', zIndex: 3 },
  estimateHeaderFixed: { paddingTop: '150px', zIndex: 2 }
});

const VoucherDetails = props => {
  const {
    classes,
    shouldShowSideDrawer,
    vendors,
    normalizeAuthSummaries,
    payeeDetails,
    authDetails,
    clientRelocationPolicies,
    clients = [],
    voucherDetail,
    voucherId,
    expenseCodes,
    enumerations,
    onUpdateVoucher,
    onSaveLineItem,
    onDeleteLineItem,
    history,
    location,
    updateParentVoucherAttachments,
    updateParentVoucherLineAttachments,
    exceptions,
    clientId,
    setExceptions,
    vendor,
    isReadOnly = false,
    //isFeeVoucher: isFeeVoucherProp = false
    pushVoucherToAcumaticaFunc,
    banks,
    handleStartOver,
    authorizationSummaries
  } = props;

  const allEnums = useMemo(() => enumerations ?? {}, [enumerations]);
  const provinces = useMemo(() => (Array.isArray(allEnums?.provinces) ? allEnums.provinces.filter(p => !!p?.isActive) : []), [allEnums]);
  const provinceTitleById = useMemo(() => {
    const map = {};
    for (const p of provinces) map[p.id] = p.title ?? '';
    return map;
  }, [provinces]);

  const [voucherInfoForm, setVoucherInfoForm] = useState(voucherDetail || {});
  const [voucherState, setVoucherState] = useState(voucherDetail || {});
  const [isLoading, setIsLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [isFormValidForApproval, setIsFormValidForApproval] = useState(false);

  const [showStartOver, setShowStartOver] = useState(false);
  const [startOverType, setStartOverType] = useState(null);

  const payeeTypeId = voucherInfoForm?.payee?.payeeTypeId;
  const payToVendor = isIdEqual(payeeTypeId, EXPENSES_PAYEE_TYPE.VENDOR);

  const vendorId = payToVendor ? voucherInfoForm?.payee?.vendorId ?? null : null;
  const authId = !payToVendor ? voucherInfoForm?.payee?.authorizationId ?? null : null;
  const isValidForReset = voucherInfoForm?.isValidForReset ?? false;

  const normalizedClients = useMemo(
    () =>
      (clients ?? []).map(c => ({
        clientRecordId: c.clientRecordId ?? c.id ?? c.clientId,
        legalName: c.legalName ?? c.clientName ?? c.description ?? '',
        id: c.clientRecordId ?? c.id ?? c.clientId,
        description: c.legalName ?? c.clientName ?? c.description ?? '',
        clientId: c.clientRecordId ?? c.id ?? c.clientId,
        clientName: c.shortName ?? c.legalName ?? c.clientName ?? c.description ?? ''
      })),
    [clients]
  );

  const normalizedVendors = useMemo(() => {
    const arr = Array.isArray(vendors) ? vendors : Object.values(vendors ?? {});
    return arr.map(v => {
      const stateId = v.stateId ?? v.provinceId ?? v.state ?? v.stateGuid ?? null;
      return { ...v, stateId, stateTitle: stateId ? provinceTitleById[stateId] ?? '' : '' };
    });
  }, [vendors, provinceTitleById]);

  const normalizedAuthorizations = useMemo(() => {
    const full = a =>
      `${(a.transfereeFirstName ?? a.firstName ?? '').trim()} ${(a.transfereeLastName ?? a.lastName ?? '').trim()}`
        .trim()
        .replace(/\s+/g, ' ');
    return (authorizationSummaries ?? []).map(a => ({
      ...a,
      fileId: a.fileId ?? a.authorizationId ?? a.authId ?? null,
      transfereeName: a.transfereeName?.trim() ? a.transfereeName : full(a),
      clientName: a.clientName ?? '',
      departureAddress: a.departureAddress ?? a.departure ?? '',
      destinationAddress: a.destinationAddress ?? a.destination ?? ''
    }));
  }, [authorizationSummaries]);

  const clientAdvInfo = useMemo(
    () => ({
      searchingColumns: [
        { name: 'clientId', title: 'Client Id' },
        { name: 'clientName', title: 'Company Name' }
      ],
      searchingColumnExtensions: [
        { columnName: 'clientId', width: 150 },
        { columnName: 'clientName', width: 250 }
      ],
      searchingRows: normalizedClients,
      idKey: 'clientId',
      nameKey: 'clientName'
    }),
    [normalizedClients]
  );

  const currentClient = normalizedClients.find(c => c.clientId === clientId) ?? null;
  const currentVendor = normalizedVendors.find(v => v.vendorId === vendorId) ?? null;
  const currentAuthorization = normalizedAuthorizations.find(a => a.fileId === authId) ?? null;

  const [payToVendorSelected, setPayToVendorSelected] = useState(payToVendor);
  const [selectedClientId, setSelectedClientId] = useState(clientId);
  const [selectedClientName, setSelectedClientName] = useState(currentClient?.clientName || '');
  const [selectedVendorId, setSelectedVendorId] = useState(vendorId);
  const [selectedVendorName, setSelectedVendorName] = useState(currentVendor?.companyName || '');
  const [selectedAuthId, setSelectedAuthId] = useState(authId);
  const [selectedAuthName, setSelectedAuthName] = useState(currentAuthorization?.transfereeName || '');
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  let terms = vendor?.vendorInfo?.terms || '';

  const addedByUserName = voucherInfoForm?.voucherInformation?.addedByUser || '';
  const mostRecentUpdater = voucherInfoForm?.mostRecentUserChange || '';

  useEffect(() => {
    if (!voucherDetail) return;
    setVoucherInfoForm(voucherDetail);
    setVoucherState(voucherDetail);
    setIsDirty(false);
  }, [voucherDetail]);

  const togglePayToVendor = useCallback(() => setPayToVendorSelected(prev => !prev), []);

  const voucherStatuses = useMemo(() => (enumerations?.voucherStatuses ?? []).filter(s => s.isActive), [enumerations]);
  const voucherCreationTypes = useMemo(() => {
    const creationTypes =
      enumerations?.voucherCreationTypes ?? enumerations?.voucherCreationType ?? enumerations?.enumVoucherCreationTypes ?? [];
    return Array.isArray(creationTypes) ? creationTypes.filter(creationType => creationType.isActive !== false) : [];
  }, [enumerations]);
  const batchTypes = useMemo(() => (enumerations?.batchTypes ?? []).filter(s => s.isActive), [enumerations]);
  const currencies = useMemo(() => (enumerations?.currencies ?? []).filter(s => s.isActive), [enumerations]);
  const voucherTypes = useMemo(() => (enumerations?.voucherTypes ?? []).filter(s => s.isActive), [enumerations]);
  const notPayables = useMemo(() => (enumerations?.notPayables ?? []).filter(s => s.isActive), [enumerations]);
  const bankPaymentMethodTypesEnums = useMemo(() => (enumerations?.bankAccountPaymentMethodTypes ?? []).filter(s => s.isActive), [enumerations]);

  const currencyOpts = useMemo(() => getCurrencyOptions(currencies), [currencies]);

  const voucherStatusId = voucherInfoForm?.voucherInformation?.voucherStatusId || ZERO_GUID;
  const isDraft = voucherStatusId === VOUCHER_STATUS.DRAFT || voucherStatusId === ZERO_GUID;
  // const isFeeVoucher =
  //   isFeeVoucherProp || isIdEqual(voucherInfoForm?.voucherInformation?.batchTypeId, EXPENSES_BATCH_TYPES.FEE);

  const isAcumaticaRejected = voucherInfoForm?.voucherInformation?.acumaticaProcessStatus === 'R';
  const localReadOnly = isReadOnly === true ? isReadOnly : !isDraft;

  const statusTitle = useMemo(
    () => voucherStatuses.find(s => String(s.id).toLocaleLowerCase() === String(voucherStatusId).toLocaleLowerCase())?.title || '—',
    [voucherStatuses, voucherStatusId]
  );
  const voucherCreationTypeId = voucherInfoForm?.voucherInformation?.voucherCreationTypeId || ZERO_GUID;
  const creationTypeTitle = useMemo(() => {
    const creationType = voucherCreationTypes.find(
      option => String(option.id).toLocaleLowerCase() === String(voucherCreationTypeId).toLocaleLowerCase()
    );
    return creationType?.title || creationType?.description || creationType?.name || '—';
  }, [voucherCreationTypes, voucherCreationTypeId]);

  const isTrackVoucher = isIdEqual(voucherInfoForm?.voucherInformation?.voucherTypeId || ZERO_GUID, TRACK_VOUCHER_TYPE_ID);

  const authOptions = useMemo(() => {
    const relevantAuthIds = [
      voucherInfoForm?.payee?.authorizationId,
      ...(voucherInfoForm?.voucherLineItems ?? []).map(lineItem => lineItem?.paymentAuthorizationId)
    ].filter(Boolean);

    return [...new Set(relevantAuthIds)].map(authId => {
      const transfereeName = (normalizeAuthSummaries ?? []).find(auth => auth.fileId === authId)?.transfereeName ?? '';
      return {
        value: authId,
        label: transfereeName ? `${transfereeName} (${authId})` : String(authId)
      };
    });
  }, [normalizeAuthSummaries, voucherInfoForm?.payee?.authorizationId, voucherInfoForm?.voucherLineItems]);

  const getVendorCompanyName = () => (payeeDetails && payeeDetails.vendorInfo ? payeeDetails.vendorInfo.companyName : '');

  const clientValue = useMemo(
    () => (clients ?? []).find(c => c.clientRecordId === voucherInfoForm?.voucherInformation?.clientId)?.shortName ?? '',
    [clients, voucherInfoForm?.voucherInformation?.clientId]
  );
  const vendorValue = payToVendor ? getVendorCompanyName() : '';
  const authValue = useMemo(
    () =>
      payToVendor
        ? ''
        : (normalizeAuthSummaries ?? []).find(auth => auth.fileId === voucherInfoForm?.payee?.authorizationId)?.transfereeName ?? '',
    [payToVendor, normalizeAuthSummaries, voucherInfoForm?.payee?.authorizationId]
  );

  const normalizeVoucher = obj => ({
    ...obj,
    voucherInformation: {
      ...obj?.voucherInformation,
      amount: obj?.voucherInformation?.amount != null && obj?.voucherInformation?.amount !== '' ? Number(obj.voucherInformation.amount) : 0,
      batchTypeId: ZERO_GUID
    }
  });

  useEffect(() => {
    setIsDirty(!_.isEqual(normalizeVoucher(voucherInfoForm), normalizeVoucher(voucherState)));
  }, [voucherInfoForm, voucherState]);

  const saveDraft = async (req = null) => {
    if (isReadOnly) return false;
    setIsLoading(true);
    const payload = normalizeVoucher(req ?? voucherInfoForm);
    const resp = await onUpdateVoucher(payload);
    if (resp?.type === UPDATE_VOUCHER_SUMMARY_FAILURE) {
      props.showToast('Failed to update the voucher, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    }

    const next = resp?.response || payload;
    setVoucherInfoForm(next);
    setVoucherState(next);
    setIsLoading(false);
    setIsDirty(false);
    return true;
  };

  const pushToAcumatica = async () => {
    if (isReadOnly) return false;
    setIsLoading(true);
    const resp = await pushVoucherToAcumaticaFunc();
    setIsLoading(false);
    if (resp?.type === POST_PUSH_VOUCHER_TO_ACUMATICA_FAILURE) {
      props.showToast('Failed to push the voucher to Acumatica, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    }
    return true;
  };

  const onVoucherCreationCancelled = () => {
    setSelectedClientId(clientId);
    setPayToVendorSelected(payToVendor);
    setSelectedClientName(currentClient?.clientName);
    setSelectedVendorId(vendorId);
    setSelectedVendorName(currentVendor?.vendorName);
    setSelectedAuthId(authId);
    setSelectedAuthName(currentAuthorization?.authName);
    setShowStartOver(false);
  }

  const onStartOverConfirmed = async () => {
    if (isReadOnly) return;
    setIsLoadingModal(true);
    let startOverTypeCalculated = payToVendor === payToVendorSelected ? VoucherStartOverTypes.CHANGE_PAYEE : VoucherStartOverTypes.CHANGE_PAYEE_TYPE;
    await handleStartOver(clientId, payToVendorSelected ? GUIDS.PAYEE_TYPE.VENDOR : GUIDS.PAYEE_TYPE.TRANSFEREE, payToVendorSelected ? selectedVendorId : selectedAuthId, startOverTypeCalculated);
    setIsLoadingModal(false);
    setShowStartOver(false);
  };

  const handleOpenStartOverForPayee = () => {
    if (isReadOnly) return;
    setStartOverType(VoucherStartOverTypes.CHANGE_PAYEE);
    setShowStartOver(true);
  };

  const handleOpenStartOverForPayeeType = () => {
    if (isReadOnly) return;
    setStartOverType(VoucherStartOverTypes.CHANGE_PAYEE_TYPE);
    setShowStartOver(true);
  };

  return (
    <Box>
      <Prompt
        when={true}
        message={() => (!isDirty ? true : 'Make sure to save any unsaved changes. Are you sure you would like to leave?')}
      />
      <Paper
        square
        className={classNames({
          'position-fixed': true,
          [classes.headerFixed]: true,
          [classes.container]: true,
          [classes.drawerOpen]: shouldShowSideDrawer
        })}
        sx={{ paddingTop: '5px', zIndex: 4, position: 'relative', width: '100%' }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px', flexWrap: 'wrap' }}>
            <Box sx={{ marginRight: '20px' }}>
              <AdvancedSearch
                labelText={'Client'}
                displayValueAccessorKey={'shortName'}
                saveIdValueAccessorKey={'clientRecordId'}
                searchingCriteria={[
                  { name: 'clientRecordId', title: 'Client Id' },
                  { name: 'shortName', title: 'Client Name' },
                  { name: 'clientCode', title: 'Client Code' }
                ]}
                searchingCriteriaExtensions={[
                  { columnName: 'clientRecordId', width: 150 },
                  { columnName: 'shortName', width: 250 },
                  { name: 'clientCode', width: 175 }
                ]}
                searchingRows={clients}
                id={voucherInfoForm?.voucherInformation?.clientId}
                value={clientValue}
                setIdValue={() => { }}
                isReadOnly={true}
              />
            </Box>
            <Box>
              <Button
                color="secondary"
                variant="contained"
                disabled={true}
                sx={{
                  maxHeight: '40px',
                  marginLeft: '12px',
                  marginTop: '8px',
                  backgroundColor: payToVendor ? '#36939b' : '#ffffff',
                  '&:hover': { backgroundColor: payToVendor ? '#15585e' : '#faf8f2' },
                  color: payToVendor ? 'ffffff' : '#080600'
                }}
              >
                Pay to Vendor
              </Button>
              <Button
                color="secondary"
                variant="contained"
                disabled={true}
                sx={{
                  maxHeight: '40px',
                  marginLeft: '12px',
                  marginTop: '8px',
                  backgroundColor: !payToVendor ? '#36939b' : '#ffffff',
                  '&:hover': { backgroundColor: !payToVendor ? '#15585e' : '#faf8f2' },
                  color: !payToVendor ? 'ffffff' : '#080600'
                }}
              >
                Pay to EE
              </Button>
            </Box>
            {payToVendor ? (
              <Box sx={{ marginLeft: '25px' }}>
                <AdvancedSearch
                  labelText={'Vendor'}
                  displayValueAccessorKey={'companyName'}
                  saveIdValueAccessorKey={'vendorId'}
                  searchingCriteria={[
                    { name: 'vendorId', title: 'Vendor Id' },
                    { name: 'companyName', title: 'Company Name' },
                    { name: 'city', title: 'City' },
                    { name: 'state', title: 'State' }
                  ]}
                  searchingCriteriaExtensions={[
                    { columnName: 'vendorId', width: 150 },
                    { columnName: 'companyName', width: 250 },
                    { name: 'city', width: 175 },
                    { name: 'state', width: 175 }
                  ]}
                  searchingRows={vendors}
                  id={voucherInfoForm?.payee?.vendorId}
                  value={vendorValue}
                  setIdValue={() => { }}
                  isReadOnly={true}
                />
              </Box>
            ) : (
              <Box sx={{ marginLeft: '25px' }}>
                <AdvancedSearch
                  labelText={'Authorization'}
                  displayValueAccessorKey={'transfereeName'}
                  saveIdValueAccessorKey={'fileId'}
                  searchingCriteria={[
                    { name: 'fileNumber', title: 'Auth Id' },
                    { name: 'transfereeName', title: 'Full Name' },
                    { name: 'departure', title: 'Departure' },
                    { name: 'destination', title: 'Destination' },
                    { name: 'clientName', title: 'Client' }
                  ]}
                  searchingCriteriaExtensions={[
                    { columnName: 'fileNumber', width: 150 },
                    { columnName: 'transfereeName', width: 250 },
                    { name: 'departure', width: 175 },
                    { name: 'destination', width: 175 },
                    { columnName: 'clientName', width: 175 }
                  ]}
                  searchingRows={normalizeAuthSummaries}
                  id={voucherInfoForm?.payee?.authorizationId}
                  value={authValue}
                  setIdValue={() => { }}
                  isReadOnly={true}
                />
              </Box>
            )}
            {!isReadOnly && isValidForReset && (
              <Box>
                <Button onClick={handleOpenStartOverForPayee}
                  color="secondary"
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px', backgroundColor: '#41B7C0', '&:hover': { backgroundColor: '#3d959c' }
                  }}
                  variant="contained"
                >
                  Update Payee
                </Button>
                <Button onClick={handleOpenStartOverForPayeeType}
                  color="secondary"
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px', backgroundColor: '#41B7C0', '&:hover': { backgroundColor: '#3d959c' }
                  }}
                  variant="contained"
                >
                  Start Over
                </Button>
              </Box>
            )}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
            <Box>
              <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                  Status
                </Typography>
              </Box>
              <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                  {statusTitle}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                  Creation Type
                </Typography>
              </Box>
              <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                  {creationTypeTitle}
                </Typography>
              </Box>
            </Box>
            {!payToVendor && isTrackVoucher && (
              <RepayAgreementInfoBox authorizationDetails={authDetails?.authorizationDetails} clientRelocationPolicies={clientRelocationPolicies} />
            )}
            <Box>
              <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                  Modified By
                </Typography>
              </Box>
              <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                  {mostRecentUpdater}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                  Added By
                </Typography>
              </Box>
              <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                  {addedByUserName}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
      <Box sx={{ paddingLeft: '16px', paddingTop: '10px' }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          {isLoading && <SpinnerComponent />}
          {!isLoading && (
            <>
              <Grid item xs={12} xl={12} rowSpacing={2}>
                <VoucherInfoCard
                  isReadOnly={localReadOnly}
                  voucherInfo={voucherInfoForm}
                  updateVoucherInfo={newInfo => {
                    if (isReadOnly) return;
                    setVoucherInfoForm(newInfo);
                    setIsDirty(true);
                  }}
                  vendors={vendors}
                  statusId={voucherStatusId}
                  voucherStatuses={voucherStatuses}
                  currencies={currencyOpts}
                  voucherTypes={voucherTypes}
                  batchTypes={batchTypes}
                  notPayables={notPayables}
                  payToVendor={payToVendor}
                  vendor={vendor}
                  terms={terms}
                  banks={banks ?? []}
                  bankPaymentMethodTypesEnums={bankPaymentMethodTypesEnums}
                />
              </Grid>
              {/* <Grid item xs={12} xl={4} rowSpacing={2}>
                <PaymentInfoCard
                  isReadOnly={localReadOnly}
                  isFeeVoucher={isFeeVoucher}
                  canUpdateVoucher={typeof onUpdateVoucher === 'function'}
                  voucherInfo={voucherInfoForm}
                  updateVoucherInfo={newInfo => {
                    setVoucherInfoForm(newInfo);
                    setIsDirty(true);
                  }}
                  updateVoucher={saveDraft}
                  voucherStatusId={voucherStatusId}
                  voucherStatuses={voucherStatuses}
                  currencies={currencyOpts}
                  batchTypes={batchTypes}
                  banks={props.banks ?? []}
                  addresses={props.addresses ?? []}
                  payToVendor={payToVendor}
                />
              </Grid> */}

              <Grid item xs={12} rowSpacing={2}>
                <VoucherLineItems
                  isReadOnly={localReadOnly}
                  payToVendor={payToVendor}
                  voucherId={voucherInfoForm?.voucherInformation?.voucherId ?? voucherId}
                  clientName={voucherInfoForm?.clientName ?? ''}
                  voucherAuthorizationId={voucherInfoForm?.payee?.authorizationId ?? null}
                  voucherLineItems={voucherInfoForm?.voucherLineItems ?? []}
                  expenseCodes={expenseCodes}
                  normalizeAuthSummaries={normalizeAuthSummaries}
                  enumerations={enumerations}
                  onAddLine={onSaveLineItem}
                  onUpdateLine={onSaveLineItem}
                  onDeleteLine={onDeleteLineItem}
                  voucherInfo={voucherState}
                  voucherInfoForm={voucherInfoForm}
                  setVoucherInfoForm={setVoucherInfoForm}
                  setVoucherState={setVoucherState}
                  isLoading={isLoading}
                  isDirty={isDirty}
                  history={history}
                  updateVoucher={saveDraft}
                  setIsLoading={setIsLoading}
                  setIsFormValidForApproval={setIsFormValidForApproval}
                  isFormValidForApproval={isFormValidForApproval}
                  updateParentVoucherAttachments={updateParentVoucherAttachments}
                  updateParentVoucherLineAttachments={updateParentVoucherLineAttachments}
                  exceptions={exceptions}
                  clientId={clientId}
                  setExceptions={setExceptions}
                  isAcumaticaRejected={isAcumaticaRejected}
                  pushVoucherToAcumaticaFunc={pushToAcumatica}
                  currencies={currencyOpts}

                />
              </Grid>

              <Grid item xs={12} rowSpacing={2}>
                <DynamicFilePreviewCard
                  authId={voucherInfoForm?.payee?.authorizationId ?? null}
                  authOptions={authOptions}
                  history={history}
                  location={location}
                  isReadOnly={true}
                />
              </Grid>


            </>
          )}
        </Grid>
      </Box>

      <Dialog open={!isReadOnly && showStartOver} fullWidth={false} maxWidth="lg">
        <Box sx={{ p: '25px' }}>
          <Typography variant="h5">Start Over</Typography>
        </Box>
        <Box sx={{ px: '25px', pt: 0 }}>
          <Typography variant="body2">Select from the base options below to get started.</Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'row', p: '10px 20px' }}>
          <Box sx={{ mr: '20px' }}>
            <AdvancedSearch
              labelText="Client"
              displayValueAccessorKey="clientName"
              saveIdValueAccessorKey="clientId"
              searchingCriteria={clientAdvInfo.searchingColumns}
              searchingCriteriaExtensions={clientAdvInfo.searchingColumnExtensions}
              searchingRows={normalizedClients}
              id={selectedClientId}
              value={selectedClientName}
              setIdValue={(id, value) => {
                setSelectedAuthId(null);
                setSelectedAuthName(null);
                setSelectedClientId(id);
                setSelectedClientName(value);
              }}
              isReadOnly={false}
              disabled={true}
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>

          <Box>
            <Button
              color="secondary"
              variant="contained"
              sx={{
                maxHeight: '40px',
                ml: '12px',
                mt: '8px',
                backgroundColor: payToVendorSelected ? '#36939b' : '#ffffff',
                '&:hover': { backgroundColor: payToVendorSelected ? '#15585e' : '#faf8f2' },
                color: payToVendorSelected ? '#ffffff' : '#080600'
              }}
              onClick={togglePayToVendor}
              disabled={isReadOnly || startOverType === VoucherStartOverTypes.CHANGE_PAYEE}
            >
              Pay to Vendor
            </Button>
            <Button
              color="secondary"
              variant="contained"
              sx={{
                maxHeight: '40px',
                ml: '12px',
                mt: '8px',
                backgroundColor: !payToVendorSelected ? '#36939b' : '#ffffff',
                '&:hover': { backgroundColor: !payToVendorSelected ? '#15585e' : '#faf8f2' },
                color: !payToVendorSelected ? '#ffffff' : '#080600'
              }}
              onClick={togglePayToVendor}
              disabled={isReadOnly || startOverType === VoucherStartOverTypes.CHANGE_PAYEE}
            >
              Pay to EE
            </Button>
          </Box>

          {payToVendorSelected ? (
            <Box sx={{ ml: '25px' }}>
              <AdvancedSearch
                labelText="Vendor"
                displayValueAccessorKey="companyName"
                saveIdValueAccessorKey="vendorId"
                searchingCriteria={[
                  { name: 'vendorId', title: 'Vendor Id' },
                  { name: 'companyName', title: 'Company Name' },
                  { name: 'city', title: 'City' },
                  { name: 'stateTitle', title: 'State' },
                  { name: 'phone', title: 'Company Phone' },
                  { name: 'email', title: 'Company Email' }
                ]}
                searchingCriteriaExtensions={[
                  { columnName: 'vendorId', width: 150 },
                  { columnName: 'companyName', width: 250 },
                  { columnName: 'city', width: 175 },
                  { columnName: 'stateTitle', width: 140 },
                  { columnName: 'phone', width: 175 },
                  { columnName: 'email', width: 175 }
                ]}
                searchingRows={normalizedVendors}
                id={selectedVendorId}
                value={selectedVendorName}
                setIdValue={(id, value) => {
                  setSelectedVendorId(id);
                  setSelectedVendorName(value);
                }}
                isReadOnly={false}
              />
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
          ) : (
            <Box sx={{ ml: '25px' }}>
              <AdvancedSearch
                labelText="Authorization"
                displayValueAccessorKey="transfereeName"
                saveIdValueAccessorKey="fileId"
                searchingCriteria={[
                  { name: 'fileNumber', title: 'Auth Id' },
                  { name: 'transfereeName', title: 'Full Name' },
                  { name: 'departureAddress', title: 'Departure Location' },
                  { name: 'destinationAddress', title: 'Destination Location' },
                  { name: 'clientName', title: 'Client' }
                ]}
                searchingCriteriaExtensions={[
                  { columnName: 'fileNumber', width: 150 },
                  { columnName: 'transfereeName', width: 250 },
                  { columnName: 'departureAddress', width: 175 },
                  { columnName: 'destinationAddress', width: 175 },
                  { columnName: 'clientName', width: 175 }
                ]}
                searchingRows={
                  selectedClientName
                    ? normalizedAuthorizations.filter(a => a.clientRecordId === selectedClientId)
                    : normalizedAuthorizations
                }
                id={selectedAuthId}
                value={selectedAuthName}
                setIdValue={(id, value) => {
                  const auth = normalizedAuthorizations.find(a => a.fileId === id);
                  setSelectedAuthId(id);
                  setSelectedAuthName(value);
                  if (auth?.clientRecordId) {
                    const c = normalizedClients.find(x => x.clientId === auth.clientRecordId);
                    if (c) {
                      setSelectedClientId(c.clientId);
                      setSelectedClientName(c.clientName);
                    }
                  }
                }}
                isReadOnly={false}
              />
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </Box>
          )}
        </Box>

        <DialogActions sx={{ p: '1.25rem' }}>
          {isLoadingModal && <Spinner />}
          {!isLoadingModal && (
            <>
              <Button onClick={onVoucherCreationCancelled} sx={{ color: '#41B7C0', '&:hover': { color: '#3d959c' } }}>
                Cancel
              </Button>
              <Button
                onClick={onStartOverConfirmed}
                color="primary"
                sx={{ backgroundColor: '#41B7C0', '&:hover': { backgroundColor: '#3d959c' } }}
                type="submit"
                variant="contained"
                disabled={
                  isReadOnly ||
                  selectedClientId == null ||
                  (payToVendorSelected && (!selectedVendorId || selectedVendorId === '' || selectedVendorId === vendorId)) ||
                  (!payToVendorSelected && (selectedAuthId == null || selectedAuthId === '' || selectedAuthId === authId))
                }
              >
                Create Voucher
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const mapStateToProps = state => {
  const {
    authorizations: { vendors }
  } = state;
  return { vendors };
};

export default compose(withStyles(styles), connect(mapStateToProps, { showToast }))(VoucherDetails);
